export default __webpack_public_path__ + "static/media/navigation.1cd7e9ab.mp3";